import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PopupProvider } from '@/context/PopupContext';
import './styles/main.scss';
import Main from '@/pages/Main';
import { Suspense, lazy } from 'react';

// Ленивые страницы
const BlogDetails = lazy(() => import('@/pages/Blog/BlogDetails'));
const BlogList = lazy(() => import('@/pages/Blog/BlogList'));
const Location = lazy(() => import('@/pages/Location'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const SearchResultPage = lazy(() => import('@/pages/SearchResult/SearchResultPage'));
const ShipDetail = lazy(() => import('@/pages/Ships/ShipDetail/ShipDetail'));
const ShipMainPage = lazy(() => import('@/pages/Ships/ShipMainPage'));
const About = lazy(() => import('@/pages/About'));
const ItineraryPage = lazy(() => import('@/pages/ItineraryPage/ItineraryPage'));
const Terms = lazy(() => import('@/pages/Terms'));

function ScrollWrapper() {
  useScrollToTop();

  return (
    <PopupProvider>
      <Header />
      <div className="page-content">
        <Suspense fallback={<div className="page-loading">
          <div className="loading-spinner">
            <svg
              className="spinner"
              viewBox="0 0 50 50"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                strokeWidth="5"
              />
            </svg>
          </div>
        </div>}>
          <Routes>
            <Route path="/location/:id" element={<Location />} />
            <Route path="/location" element={<Navigate to="/" replace />} />
            <Route path="/yachts/:category/:id" element={<ShipDetail />} />
            <Route path="/yachts/:category" element={<ShipMainPage />} />
            <Route path="/yachts" element={<Navigate to="/" replace />} />
            <Route path="/search-result" element={<SearchResultPage />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/itinerary/:slug" element={<ItineraryPage />} />
            <Route path="/itinerary" element={<Navigate to="/" replace />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/" element={<Main />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </PopupProvider>
  );
}

function App() {
  return (
    <div className="App page-layout">
      <Router>
        <ScrollWrapper />
      </Router>
    </div>
  );
}

export default App;
